module.exports = __webpack_public_path__ + "static/media/extra_large_bedroom.5433dc3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/extra_large_bedroom.png
// module id = 796
// module chunks = 0